import Select from 'react-select';

import { SelectMenu, SelectCustomDropdown } from '../components';

const CustomSelect = (props) => {
  return (
    <Select
      value={props.selected}
      name="formats"
      components={{
        IndicatorSeparator: () => null,
        Menu: props.CustomMenu ? props.CustomMenu : SelectMenu,
        DropdownIndicator: SelectCustomDropdown,
      }}
      options={props.options}
      onChange={props.onChangeHandler}
      getOptionLabel={(option) =>
        props.customLabel ? option[props.customLabel] : option.label ? option.label : option.value
      }
      placeholder={props.placeholder ? props.placeholder : "Начните вводить"}
      getOptionValue={(option) => (props.customValue ? option[props.customValue] : option.value)}
      isOptionDisabled={props.isOptionDisabled ? props.isOptionDisabled : () => null}
      styles={{
        control: (css) => ({
          ...css,
          backgroundColor: 'transparent',
          width: '100%',
          minWidth: '200px',
          borderColor: '#E2E8F0',
        }),
        input: (css) => ({
          ...css,
          color: `${props.theme === 'white' ? 'white' : 'black'}`,
          outline: 'none',
        }),
        indicatorContainer: (css) => ({ ...css, outline: 'none', padding: '200px' }),
        singleValue: (css) => ({
          ...css,
          color: props.theme === 'white' ? '#E2E8F0' : '#1E293B',
          marginRight: '0px',
        }),
        valueContainer: (provided, state) => ({
          ...provided,
          padding: '2px 0px 2px 8px',
          fontSize: '14px',
        }),
        container: (css) => ({ ...css, width: '100%' }),
        menuList: (css) => ({
          ...css,
          overflow: 'auto',
          maxHeight: '160px',
        }),
      }}
    />
  );
};

export default CustomSelect;
